export default function getBaseApi() {
  return "https://webservicesnt.org:4464";
  // return "http://192.168.217.8:5005";
}
